const Dict = {}
Dict.FANFANLE_PROPS = {
  jf: {
    img: 'jf.png',
    name: '积分',
  },
  '0_500': {
    img: '0_500.png',
    name: '500金蛋',
  },
  '0_1000': {
    img: '0_1000.png',
    name: '1000金蛋',
  },
  '0_3000': {
    img: '0_3000.png',
    name: '3000金蛋',
  },
  '0_5000': {
    img: '0_5000.png',
    name: '5000金蛋',
  },
  '0_10000': {
    img: '0_10000.png',
    name: '1万金蛋',
  },
  '0_50000': {
    img: '0_50000.png',
    name: '5万金蛋',
  },
  '0_100000': {
    img: '0_100000.png',
    name: '10万金蛋',
  },
  '0_200000': {
    img: '0_200000.png',
    name: '20万金蛋',
  },
  '0_500000': {
    img: '0_500000.png',
    name: '50万金蛋',
  },
  '2_4': {
    img: '2_4.png',
    name: '双倍积分卡(时)',
  },
  '2_5': {
    img: '2_5.png',
    name: '双倍积分卡(日)',
  },
  '2_6': {
    img: '2_6.png',
    name: '双倍积分卡(周)',
  },
  '2_7': {
    img: '2_7.png',
    name: '负分清零',
  },
  '2_11': {
    img: '2_11.png',
    name: '护身符(日)',
  },
  '2_12': {
    img: '2_12.png',
    name: '护身符(周)',
  },

  '2_22': {
    img: '2_22.png',
    name: 'VIP1年',
  },
  '2_31': {
    img: '2_31.png',
    name: '战队卡',
  },

  '2_1002': {
    img: '2_1002.png',
    name: '玫瑰花x5',
  },
  '2_1003': {
    img: '2_1003.png',
    name: '臭鸡蛋x5',
  },
  '2_1004': {
    img: '2_1004.png',
    name: '爱心x5',
  },
  '2_404001': {
    img: '2_404001.png',
    name: '100元话费',
  },
  '2_40303': {
    img: '2_40303_1.png',
    name: '深海子弹',
  },
  '2_40303_1': {
    img: '2_40303_1.png',
    name: '1万深海子弹',
  },
  '2_40303_2': {
    img: '2_40303_1.png',
    name: '2万深海子弹',
  },
  '2_40303_5': {
    img: '2_40303_5.png',
    name: '5万深海子弹',
  },
  '2_40303_10': {
    img: '2_40303_10.png',
    name: '10万深海子弹',
  },
  '2_40303_50': {
    img: '2_40303_10.png',
    name: '50万深海子弹',
  },
  '2_40303_100': {
    img: '2_40303_100.png',
    name: '100万深海子弹',
  },
  '2_40303_300': {
    img: '2_40303_100.png',
    name: '300万深海子弹',
  },
  '3_1': {
    img: '3_1.png',
    name: '黄金月卡',
  },
  '3_2': {
    img: '3_2.png',
    name: '星耀月卡',
  },
  '3_3': {
    img: '3_3.png',
    name: '至尊月卡',
  },
}
Dict.backpag = {
  1: {
    name: '小喇叭',
    img: '001'
  },
  4: {
    name: '双倍积分卡(时)',
    img: '002'
  },
  5: {
    name: '双倍积分卡(日)',
    img: '006'
  },
  6: {
    name: '双倍积分卡(周)',
    img: '007'
  },
  7: {
    name: '负分清零',
    img: '003'
  },
  9: {
    name: '逃跑清零',
    img: '016'
  },
  10: {
    name: '护身符(小时)',
    img: '004'
  },
  11: {
    name: '护身符(日)',
    img: '008'
  },
  12: {
    name: '护身符(周)',
    img: '009'
  },
  13: {
    name: '小喇叭(10个)',
    img: '010'
  },
  14: {
    name: '小喇叭(50个)',
    img: '011'
  },
  25: {
    name: '黄色VIP(7天)',
    img: '027'
  },
  15: {
    name: '黄色VIP(一个月)',
    img: '005'
  },
  20: {
    name: '紫色VIP(一个月)',
    img: '025'
  },
  21: {
    name: '皇冠(一个月)',
    img: '026'
  },
  22: {
    name: '黄色VIP(一年)',
    img: '005'
  },
  23: {
    name: '紫色VIP(一年)',
    img: '025'
  },
  24: {
    name: '皇冠(一年)',
    img: '026'
  },
  1001: {
    name: '烟花',
    img: '012'
  },
  1002: {
    name: '玫瑰花',
    img: '013'
  },
  1003: {
    name: '臭鸡蛋',
    img: '014'
  },
  1004: {
    name: '爱心',
    img: '015'
  },
  1501: {
    name: '烟花(10个)',
    img: '021'
  },
  1502: {
    name: '玫瑰花(10个)',
    img: '022'
  },
  1503: {
    name: '臭鸡蛋(10个)',
    img: '023'
  },
  1504: {
    name: '爱心(10个)',
    img: '024'
  },
  20020: {
    name: '周赛门票',
    img: '028'
  },
  27: {
    name: '改名卡',
    img: '029'
  },
  31: {
    name: '战队卡',
    img: '031'
  },
  20032: {
    name: '深海深海万元大奖赛门票',
    img: '032'
  },
  20041: {
    name: '信阳ISS决赛30强门票',
    img: '032'
  },
  20042: {
    name: '信阳ISS决赛5强门票',
    img: '032'
  },
  20043: {
    name: '信阳ISS总决赛门票',
    img: '032'
  },
  20044: {
    name: '双升周赛门票',
    img: '028'
  },
  20045: {
    name: '大师资格凭证',
    img: '032'
  },
  20046: {
    name: '二人斗地主门票',
    img: '033'
  },
  40508: {
    name: '奥运赛门票',
    img: '40508'
  },

}

// Dict.menuConfig = [
//   {key: 1, name: '战队首页'},
//   {key: 2, name: '比赛成绩'},
//   {
//     key: 3,
//     name: '我的战队',
//     children: [
//       {key: '3_1', name: '战队建设'},
//       {key: '3_2', name: '战队仓库'},
//     ]
//   },
//   {
//     key: 4,
//     name: '战队管理',
//     children: [
//       {key: '4_1', name: '成员管理'},
//       {key: '4_2', name: '入队审批'},
//       {key: '4_3', name: '奖励发放'},
//       {key: '4_4', name: '奖励领取'},
//       {key: '4_5', name: '战队扩容'},
//     ]
//   },
//   {key: 5, name: '公约指南'},
// ]

Dict.ROLES = {
  CAPTAIN: 'CAPTAIN', // 会长
  VICE_CAPTAIN: 'VICE_CAPTAIN', //副会长
  ELITE: 'ELITE',   // 精英
  ORDINARY: 'ORDINARY', //成员
  NONE: 'NONE' // 未加入战队
}

Dict.ROLES_STR = {
  CAPTAIN: '队长',
  VICE_CAPTAIN: '副队长',
  ELITE: '精英',
  ORDINARY: '队员',
  NONE: '未加入战队'
}

Dict.pay = {
  Weixin: 'wechat',
  Alipay: 'alipay'
}
Dict.SIGNIN_PROPS = {
  1: {
    img: '1.png',
    title: '双倍',
    text: '双倍卡双倍卡123asd',
    id: 183360
  },
  2: {
    img: '1.png',
    title: '双倍',
    text: '双倍卡双倍卡123asd',
    id: 183361
  },
  13: {
    img: '1.png',
    title: '双倍',
    text: '双倍卡双倍卡123asd',
    id: 183362
  }
}

Dict.TOTAL_PROPS = {
  7: {
    img: '1.png',
    title: '双倍',
    text: '双倍卡双倍卡123asd',
    id: 183363
  }
}

Dict.payTypes = {
  // alipay: {
  //   payment_name: '支付宝',
  //   payment_type: 2,
  // },
  // wechat: {
  //   payment_name: '微信支付',
  //   payment_type: 15,
  // },
  // fuiou_alipay: {
  //   payment_name: '富友_支付宝',
  //   payment_type: 64,
  // },
  fuiou_wechat: {
    payment_name: '富友_微信',
    payment_type: 65,
  },
  furuyun_wechat: {
    payment_name: '付如云_微信',
    payment_type: 117,
  },
  bill99_wechat: {
    payment_name: '快钱_微信',
    payment_type: 124,
  },
  yop_wechat: {
    payment_name: '易宝_微信',
    payment_type: 70,
  }
}
export default Dict;
